// PDP - Smart Breadcrumb Replacement Script (Smooth for All)

document.addEventListener('DOMContentLoaded', function() {
  
  // Function to check if user came from a collection page
  function cameFromCollection() {
    const referrer = document.referrer;
    
    // Check if referrer is a collection page
    const isFromCollection = referrer && (
      referrer.includes('/collections/') ||
      referrer.includes('/collection/')
    );
    
    // Check if referrer is NOT search, homepage, or other non-collection pages
    const isFromSearch = referrer && referrer.includes('/search');
    const isFromHomepage = referrer && (referrer.endsWith('/') || referrer.includes('/?'));
    const isFromBlog = referrer && referrer.includes('/blogs/');
    
    return isFromCollection && !isFromSearch && !isFromHomepage && !isFromBlog;
  }
  
  // Function to replace breadcrumbs with stored collection breadcrumbs
  function processBreadcrumbs() {
    const breadcrumbNav = document.querySelector('.custom-breadcrumbs');
    const breadcrumbList = document.querySelector('.custom-breadcrumbs ul');
    
    if (!breadcrumbNav) {
      return;
    }
    
    // Check for stored breadcrumbs
    const stored = sessionStorage.getItem('lastCollectionBreadcrumbs');
    
    let shouldReplace = false;
    
    if (stored && cameFromCollection()) {
      try {
        const data = JSON.parse(stored);
        
        // Check if data is recent (within 30 minutes)
        const thirtyMinutes = 30 * 60 * 1000;
        const isRecent = (Date.now() - data.timestamp) < thirtyMinutes;
        
        if (isRecent && data.collections && data.collections.length > 0 && breadcrumbList) {
          // Build new breadcrumb HTML
          let newBreadcrumbHTML = '';
          
          // Add all stored collection breadcrumbs
          data.collections.forEach(function(item) {
            newBreadcrumbHTML += `<li class="items loop_items"><a class="link-faded" href="${item.url}"><span class="reversed-link hover:show">${item.title}</span></a></li>`;
          });
          
          // Add current product (active, no link)
          const productTitle = getProductTitle();
          newBreadcrumbHTML += `<li class="items prod_item active" aria-current="page">${productTitle}</li>`;
          
          // Replace the breadcrumb content
          breadcrumbList.innerHTML = newBreadcrumbHTML;
          shouldReplace = true;
        }
        
        if (!isRecent) {
          sessionStorage.removeItem('lastCollectionBreadcrumbs');
        }
        
      } catch (error) {
        sessionStorage.removeItem('lastCollectionBreadcrumbs');
      }
    }
    
    if (!shouldReplace && stored && !cameFromCollection()) {
      // Clear stored breadcrumbs since user didn't come from collection
      sessionStorage.removeItem('lastCollectionBreadcrumbs');
    }
    
    // Always show breadcrumbs with smooth effect (whether replaced or default)
    breadcrumbNav.classList.add('breadcrumbs-ready');
  }
  
  // Function to get product title reliably
  function getProductTitle() {
    // Try different selectors for product title
    const selectors = [
      'h1.product-title',
      'h1[data-product-title]',
      '.product-title h1',
      'h1',
      '.product-meta h1'
    ];
    
    for (let selector of selectors) {
      const element = document.querySelector(selector);
      if (element && element.textContent.trim()) {
        return element.textContent.trim();
      }
    }
    
    return 'Product'; // Fallback
  }
  
  // Process breadcrumbs immediately
  processBreadcrumbs();
  
});